import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { createParty } from '../api/client.js';
import {
  ACTIVE_PARTIES_QUERY_KEY,
  PAST_PARTIES_QUERY_KEY,
  RESOLVE_PARTY_QUERY_KEY_PREFIX,
} from '../api/queryKeys.js';

import { useMyPartyInvalidation } from './useMyPartyInvalidation.js';

import type { CreatePartyRequest, CreatePartyResponse } from '@mixwire/contracts';

export const useCreateParty = (): UseMutationResult<
  CreatePartyResponse,
  Error,
  CreatePartyRequest
> => {
  const queryClient = useQueryClient();
  const invalidateMyParty = useMyPartyInvalidation();

  return useMutation({
    mutationFn: createParty,
    onSuccess: () => {
      // The name was looked up seconds ago and came back free; that cached
      // "no such party" is exactly the party that now exists.
      void queryClient.invalidateQueries({ queryKey: RESOLVE_PARTY_QUERY_KEY_PREFIX });
      void queryClient.invalidateQueries({ queryKey: ACTIVE_PARTIES_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: PAST_PARTIES_QUERY_KEY });
      invalidateMyParty();
    },
  });
};
